import * as React from 'react'
import type { SVGProps } from 'react'
const SvgProfile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={21}
    height={18}
    viewBox="0 0 21 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.48828 16.5C2.81369 14.2892 5.71856 12.7762 10.2506 12.7762C14.7826 12.7762 17.6874 14.2892 19.0128 16.5M13.8506 5.1C13.8506 7.08823 12.2388 8.7 10.2506 8.7C8.26233 8.7 6.65056 7.08823 6.65056 5.1C6.65056 3.11177 8.26233 1.5 10.2506 1.5C12.2388 1.5 13.8506 3.11177 13.8506 5.1Z"
      stroke="#4F5277"
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
)
export default SvgProfile
